import lemonway from '../Image/lemonway.png';

function Partner() {
  return (
    <div className='redesSociales'>
        <h3 className='footerTitle'>PARTNER</h3>
            <img src={lemonway} alt="logo Lemonway" />
    </div>
  );
}

export default Partner;